export const DEVELOPMENT = 'development';
const APPSTEST = 'appstest';
const STAGING = 'staging';
const QA = 'qa';
const BOUNTY = 'bounty';
const PARTNER = 'partner';
export const PRODUCTION = 'production';
const PREVIEW = 'preview';

type EnvType =
  | typeof DEVELOPMENT
  | typeof APPSTEST
  | typeof STAGING
  | typeof PRODUCTION
  | typeof QA
  | typeof BOUNTY
  | typeof PARTNER
  | typeof PREVIEW;

const envURLs = [
  { env: DEVELOPMENT, url: 'localhost:3004' },
  { env: APPSTEST, url: 'store-appstest.dev-common.tgtg.ninja' },
  { env: STAGING, url: 'store-staging.dev-common.tgtg.ninja' },
  { env: QA, url: 'store-qa.dev-common.tgtg.ninja' },
  { env: BOUNTY, url: 'store-bounty.dev-common.tgtg.ninja' },
  { env: PARTNER, url: 'store-partner.dev-common.tgtg.ninja' },
  { env: PRODUCTION, url: 'store.toogoodtogo.com' },
  { env: PREVIEW, url: 'store-preview.dev-common.tgtg.ninja' },
];

export const fromURL = ({ href }: Location) => {
  const { hostname } = new URL(href);
  switch (true) {
    case hostname === 'charity-appstest.dev-common.tgtg.ninja':
      return APPSTEST;
    case hostname === 'charity-staging.dev-common.tgtg.ninja':
      return STAGING;
    case hostname === 'charity-qa.dev-common.tgtg.ninja':
      return QA;
    case hostname === 'charity-partner.dev-common.tgtg.ninja':
      return PARTNER;
    case hostname === 'charity-bounty.dev-common.tgtg.ninja':
      return BOUNTY;
    case hostname === 'charity-preview.dev-common.tgtg.ninja':
      return PREVIEW;
    case hostname === 'charity.toogoodtogo.com':
    case hostname === 'charity-prod.pr-be-euw1.tgtg.ninja':
    case hostname === 'charity-prod.pr-be-use1.tgtg.ninja':
    case hostname === 'charity-prod.pr-be-apse2.tgtg.ninja':
      return PRODUCTION;
    default:
      return DEVELOPMENT;
  }
};

export const getEnvURL = (env: EnvType) => envURLs.find((e) => e.env === env);
